import { oneOf } from 'prop-types';
import React from 'react';

import DefaultCard from './components/DefaultCard';
import FeatureCard from './components/FeatureCard';

import styles from './KeyDevelopmentDetails.module.scss';

const VARIANTS = {
  FEATURE: 'feature',
  DEFAULT: 'default',
  SHORT: 'short',
  DEFAULT_SHORT: 'defaultShort',
};

const KeyDevelopmentDetails = (props) => {
  const { variant,theme } = props;
  return (
    <section style={{backgroundColor:theme?.value}} className={styles.wrapper}>
      {variant === VARIANTS.FEATURE ? (
        <FeatureCard {...props} />
      ) : (
        <DefaultCard {...props} />
      )}
    </section>
  );
};

KeyDevelopmentDetails.propTypes = {
  variant: oneOf(Object.values(VARIANTS)),
};

KeyDevelopmentDetails.defaultProps = {
  variant: VARIANTS.DEFAULT,
};

export default KeyDevelopmentDetails;
